import { useEffect, useState } from 'react';
import { styled } from 'styled-components';
import { getGuestTickets, GuestTicket } from 'src/apis/utils/ticket/ticket';
import InfoNotFound from '../modal/InfoNotFound';
import CancelConfirm from '../modal/CancelConfirm';
import CancelComplete from '../modal/CancelComplete';

export default function ReservationInfo({
  festivalId,
}: {
  festivalId: number;
}) {
  const [ticket, setTicket] = useState<GuestTicket | null>(null);
  const [showNotFoundModal, setShowNotFoundModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);
  const [currentModal, setCurrentModal] = useState<string | null>(null);

  const openModal = (modalName: string) => {
    setCurrentModal(modalName);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setCurrentModal(null);
  };
  const fetchData = async () => {
    try {
      const data = await getGuestTickets(festivalId);
      if (data.length > 0) {
        setTicket(data[0]);
      } else {
        setShowNotFoundModal(true);
      }
    } catch (err) {
      setShowNotFoundModal(true);
    }
  };

  const renderModal = () => {
    if (!modalOpen) return null;

    switch (currentModal) {
      case 'CancelComplete':
        return <CancelComplete onClose={closeModal} />;

      default:
        return null;
    }
  };

  useEffect(() => {
    fetchData();
  }, [festivalId]);

  if (showNotFoundModal) {
    return <InfoNotFound onClose={() => setShowNotFoundModal(false)} />;
  }

  if (!ticket) return null; // 아직 로딩 중이거나 모달 띄우는 중

  return (
    <InfoContainer>
      <TitleArea>사전예약 정보</TitleArea>
      <InfoBox>
        <InfoDetail>
          전화번호<span>{ticket.phoneNumber}</span>
        </InfoDetail>
        <InfoDetail>
          예약번호<span>{ticket.reservationNumber}</span>
        </InfoDetail>
        <InfoDetail>
          예약회차<span>{ticket.eventName}</span>
        </InfoDetail>
        <InfoDetail>
          예약매수<span>{ticket.count}매</span>
        </InfoDetail>
      </InfoBox>
      {/* 이미 취소된 예약일 경우, 버튼이 뜨지 않음 */}
      {!ticket.canceled ? (
        <CancelConfirmButton onClick={() => setShowCancelModal(true)}>
          사전예약 취소하기
        </CancelConfirmButton>
      ) : (
        <AlreadyCanceled>사전예약 취소 완료</AlreadyCanceled>
      )}

      {showCancelModal && (
        <CancelConfirm
          onClose={() => setShowCancelModal(false)}
          reservationNumber={ticket.reservationNumber}
          refetchTickets={fetchData}
          openModal={openModal}
        />
      )}
      {renderModal()}
    </InfoContainer>
  );
}

const InfoContainer = styled.div`
  margin-top: 20px;
  width: 100%;
  padding: 0 48px;
`;
const TitleArea = styled.div`
  color: #111;
  font-family: 'GmarketSansBold';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px; /* 144.444% */
  letter-spacing: -0.45px;

  margin: 16px 0;
`;
const InfoBox = styled.div`
  display: inline-flex;
  width: 100%;
  height: 100%;
  padding: 12px 18px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex-shrink: 0;
  gap: 8px;
  border-radius: 16px;
  border: 1px solid #0b2873;
  background: #fff;
`;
const InfoDetail = styled.div`
  color: #303030;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 22.4px */
  span {
    margin-left: 6px;
    color: #111;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%; /* 22.4px */
  }
`;

const CancelConfirmButton = styled.button`
  margin-top: 32px;
  width: 100%;
  color: #fff;
  font-family: 'GmarketSansBold';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: -0.45px;

  border-radius: 8px;
  background: #0b2873;
  display: flex;
  padding: 13px;
  justify-content: center;
  align-items: center;
`;

const AlreadyCanceled = styled.button`
  cursor: not-allowed;
  margin-top: 32px;
  width: 100%;
  color: #fff;
  font-family: 'GmarketSansBold';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: -0.45px;

  border-radius: 8px;
  background: #b5bed9;
  display: flex;
  padding: 13px;
  justify-content: center;
  align-items: center;
`;
